import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectContactComponent } from './components/select/select-contact/select-contact.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactLabelComponent } from './components/label/contact-label/contact-label.component';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomerNotePipe } from './pipes/customer-note.pipe';
import { ContactPipe } from './pipes/contact.pipe';
import { CustomerPipe } from './pipes/customer.pipe';
import { SelectCustomerDialogComponent } from './components/dialog/select-customer-dialog/select-customer-dialog.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CustomerPreviewComponent } from './components/preview/customer-preview/customer-preview.component';
import { CreateCustomerDialogComponent } from './components/dialog/create-customer-dialog/create-customer-dialog.component';
import { CustomerFormComponent } from './components/embedded/customer-form/customer-form.component';
import { SharedModule } from '../shared/shared.module';
import { QuillModule } from 'ngx-quill';
import { CustomerDetailViewComponent } from './components/main/customer-detail-view/customer-detail-view.component';
import { LocationModule } from '../location/location.module';
import { CustomerContractItemsComponent } from './components/embedded/customer-contract-items/customer-contract-items.component';
import { MatTableModule } from '@angular/material/table';
import { ProductModule } from '../product/product.module';
import { ContractModule } from '../contract/contract.module';
import { MatSortModule } from '@angular/material/sort';
import { MatMenuModule } from '@angular/material/menu';
import { ContactTableComponent } from './components/embedded/contact-table/contact-table.component';
import { SelectContactDialogComponent } from './components/dialog/select-contact-dialog/select-contact-dialog.component';
import { ContactPreviewComponent } from './components/embedded/contact-preview/contact-preview.component';
import { ContactDetailViewComponent } from './components/main/contact-detail-view/contact-detail-view.component';
import { ContactFormComponent } from './components/embedded/contact-form/contact-form.component';
import { SelectContactInformationTypeComponent } from './components/select/select-contact-information-type/select-contact-information-type.component';
import { ContactInformationTableComponent } from './components/embedded/contact-information-table/contact-information-table.component';
import { ContactInformationTypeIconPipe } from './pipes/contact-information-type-icon.pipe';
import { CustomerTableComponent } from './components/embedded/customer-table/customer-table.component';
import { CreateContactDialogComponent } from './components/dialog/create-contact-dialog/create-contact-dialog.component';
import { ContactInformationTypeNamePipe } from './pipes/contact-information-type-name.pipe';
import { DeleteCustomerRequestDialogComponent } from './components/dialog/delete-customer-request-dialog/delete-customer-request-dialog.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
    SelectContactComponent,
    ContactLabelComponent,
    CustomerPreviewComponent,
    ContactPreviewComponent,
    CustomerNotePipe,
    ContactPipe,
    CustomerPipe,
    SelectCustomerDialogComponent,
    CreateCustomerDialogComponent,
    CustomerFormComponent,
    CustomerDetailViewComponent,
    CustomerContractItemsComponent,
    ContactTableComponent,
    SelectContactDialogComponent,
    ContactDetailViewComponent,
    ContactFormComponent,
    SelectContactInformationTypeComponent,
    ContactInformationTableComponent,
    ContactInformationTypeIconPipe,
    CustomerTableComponent,
    CreateContactDialogComponent,
    ContactInformationTypeNamePipe,
    DeleteCustomerRequestDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    LocationModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatToolbarModule,
    MatTableModule,
    ContractModule,
    MatSortModule,
    ProductModule,
    MatMenuModule,
    QuillModule.forRoot()
  ],
  exports: [
    ContactLabelComponent,
    CustomerNotePipe,
    ContactPreviewComponent,
    ContactPipe,
    CustomerPipe,
    CustomerPreviewComponent,
    SelectContactComponent,
    CreateCustomerDialogComponent,
    CustomerDetailViewComponent,
    ContactDetailViewComponent
  ]
})
export class CustomerModule { }
